import { useEffect, useState } from "react";
import api from "../lib/api";

// Module-level cache so multiple components share one fetch
let cached = null;
let pending = null;

export function useSettings() {
  const [settings, setSettings] = useState(cached);

  useEffect(() => {
    if (cached) return;
    if (!pending) {
      pending = api.get("/settings").then((r) => {
        cached = r.data;
        return cached;
      }).catch(() => null);
    }
    pending.then((s) => { if (s) setSettings(s); });
  }, []);

  return settings;
}
